// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hlaj","footer":"styles_footer__t6VmG"};